import { Modal, TextWithBreaks } from "@msys/ui";
import React from "react";
import type { CategoryFragment } from "./useCategories.generated.js";

interface Props {
  handleClose: () => void;
  category: CategoryFragment;
}

export const CategoryInfoModal = ({ category, handleClose }: Props) => {
  return (
    <Modal maxWidth="sm" title={category.name} handleClose={handleClose}>
      {category.description && <TextWithBreaks text={category.description} />}
    </Modal>
  );
};

export function hasCategoryInfo(category: CategoryFragment) {
  return Boolean(category.description);
}
